module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1512-c4eba63c9bd6255dba83ae02b56a2c5b.png";